import * as yup from 'yup';

export const phaseSchema = yup.object({
  // make sure name is as phase- and then a number
  name: yup.string().matches(/Phase-\d+/, 'name must be in the format of Phase-1').required('name is required'),
  mapType: yup.string().required('map type is required'),
  mediaUrl: yup.string().required('meida url is required'),
  mapBackgroundColor: yup.string().required('map background color is required'),
  mapImage: yup.string().required('map image is required'),
});
